<template>
    <div class="content flex-sub wrapper flex padding-lr-sm">
        <div class="flex flex-direction flex-sub bg-white">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form" labelWidth="auto">
                <el-form-item ref="content" label="活动内容" prop="content">
                    <div class="detail" v-html="ruleForm.content"></div>
                </el-form-item>
                <el-form-item ref="meun_id" label="活动主题" prop="meun_id" >
                    <el-select
                        v-model="ruleForm.meun_id"
                        class="w-all"
                        placeholder="请选择" disabled>
                        <el-option
                            v-for="(item) in themes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item ref="activity_time" label="活动时间" prop="activity_time">
                    <el-date-picker
                        v-model="ruleForm.activity_time"
                        placeholder="选择日期"
                        type="date"
                        value-format="yyyy-MM-dd" disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item ref="remark" label="内容补充" prop="remark">
                    <el-input v-model="ruleForm.remark" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item ref="brief_report" label="活动简报" prop="brief_report">
                    <ck-basic-editor class="bg-gray" :content="content" @watchEditor="watchEditor"></ck-basic-editor>
                </el-form-item>
            </el-form>
            <div class="flex align-center justify-end margin-top">
                <el-button :loading="loading" class="btn min" type="primary" @click="submitForm('ruleForm')">发布
                </el-button>
            </div>
        </div>
        <el-button class="choose-model bg-white text-red" round @click="templateDialog = true"><i class="el-icon-s-operation"></i>推荐模版</el-button>
        <template-dialog :dialog-visible="templateDialog" :type="0" @watchState="watchState"></template-dialog>
    </div>
</template>

<script>

import {TOAST, toast} from "@/utils/utils";
import {
    addThemeActivitiesSummary,
    getThemeActivitiesDetail,
    getThemeClassifyList
} from "@/api";
import {BASE_URL} from "@/config";
import CkBasicEditor from "@/views/web/components/CKBasicEditor";
import TemplateDialog from "@/views/web/manager/page/standard/components/TemplateDialog";

export default {
    name: "ActivitiesSummary",
    components: {TemplateDialog, CkBasicEditor},
    data() {
        return {
            BASE_URL:BASE_URL,
            content:'',
            ruleForm: {
                content: '',
                activity_time: '',
                meun_id: '',
                remark: '',
                brief_report: '',
            },
            rules: {
                brief_report: [
                    {required: true, message: '请输入活动简报', trigger: 'change'},
                ]
            },
            themes:[],
            loading: false,
            readonly:true,
            status:1,
            templateDialog: false,
        }
    },
    props: {
        aid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.getThemeClassifyList()
        if (this.aid) this.init()
    },
    methods: {
        async getThemeClassifyList() {
            let _data = await getThemeClassifyList()
            this.themes = _data.data
        },
        async init() {
            let _data = await getThemeActivitiesDetail(this.aid)
            this.ruleForm.content = _data.data.content
            this.ruleForm.meun_id = _data.data.meun_id || ''
            this.ruleForm.activity_time = _data.data.activity_time
            this.ruleForm.remark = _data.data.remark
            this.ruleForm.brief_report = _data.data.brief_report
            this.content = _data.data.brief_report
            this.status = _data.data.status
        },
        watchEditor(data) {
            this.ruleForm.brief_report = data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem();
                }
            });
        },
        async addItem() {
            this.loading = true
            let _data = await addThemeActivitiesSummary(this.aid,this.ruleForm.content,this.ruleForm.meun_id,this.ruleForm.remark,this.ruleForm.brief_report)
            this.loading = false
            if (_data.status === 200) {
                toast('发布成功', TOAST.success)
                this.$emit('watchNext', this.aid,false)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        watchState(data) {
            if (data) {
                this.ruleForm.brief_report = data.content
                this.content = data.content
            }
            this.templateDialog = false;
        }
    },
    filters: {

    },
    watch: {
        aid() {
            if (this.aid) {
                this.init();
            } else {
                this.content = ''
                this.$refs.ruleForm.resetFields()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    .choose-model {
        position: absolute;
        bottom: 200px;
        right: 30px;
    }
    .templates{
        width: 300px;
        border: 1px solid #eeeeee;
        .operate{
            height: 50px;
        }
    }
}
</style>